export const gameData = [
    
    {
        "id": 0,
        "title": "Mystery Dungeon",
        "author": "Donovan",
        "desc": "Navigate this pixel-art maze and find out just what is beyond the next corridor.",
        "resX": "800px",
        "resY": "600px",
        "link": "https://arcaderepo.netlify.com/games/donnovan/index.html"
        }, {
        "id": 1,
        "title": "Platforming Challenge",
        "author": "Lilli",
        "desc": "Classic platforming at its finest! See if you can collect all of the apples in the area to continue on to the next zone.",
        "resX": "800px",
        "resY": "600px",
        "link": "https://arcaderepo.netlify.com/games/lili/index.html"
    }, {
        "id": 2,
        "title": "Candy Maze",
        "author": "Ebbe",
        "desc": "Navigate tricky mazes and avoid enemies to collect candy. Up to players can join in on the fun!",
        "resX": "1000",
        "resY": "532px",
        "link": "https://arcaderepo.netlify.com/games/candymaze/index.html"
    }, {
        "id": 3,
        "title": "The Gold Chase",
        "author": "Dalifanam Studios",
        "desc": "A part of the Digital Design & Production 2022 session. This game tasks the main character, Marcus, with retrieving his stolen gold from the Pines Gang of Market City. This gold will be used to support his life in Fairview with his sister, Mya. Along the way Marcus will have to battle through hordes of gang members to find Ryker, the villainous leader of the Pines.",
        "resX": "1280",
        "resY": "720px",
        "link": "https://arcaderepo.netlify.com/games/digitaldesignproduction2022/index.html"
    }, {
        "id": 4,
        "title": "The Elemental Psycho",
        "author": "Kobe",
        "desc": "An action-platformer where the player is tasked with fighting The 5 Stages of Grief",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/kobe/index.html"
    }, {
        "id": 5,
        "title": "The Get-Away",
        "author": "Zakoye",
        "desc": "A Zombie Shooter in a semi-3D world",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/zakoye/index.html"
    }, {
        "id": 6,
        "title": "The Purifier",
        "author": "Ethan",
        "desc": "An Action Platformer. Confront The Seven Deadly Sins and their hordes of minions.",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/ethan/index.html"
    }, {
        "id": 7,
        "title": "Spacey-Wacey",
        "author": "Jveon",
        "desc": "Intergalactic Conquest! Conquer the stars in this space-flight sim.",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/jveon/index.html"
    }, {
        "id": 8,
        "title": "Asteroid",
        "author": "Dior",
        "desc": "An infinite runner with a space-ship twist. Avoid the asteroids! ",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/dior/index.html"
    }, {
        "id": 9,
        "title": "Turbo Racer",
        "author": "Manny",
        "desc": "Outrun an impending snow storm in your suped up car.",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/manny/index.html"
    }, {
        "id": 10,
        "title": "Jumel's Game",
        "author": "Jumel",
        "desc": "Navigate a rain-drenched world while avoiding a mysterious enemy!",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/jumel/index.html"
    }, {
        "id": 11,
        "title": "Cursed Adventure",
        "author": "Digital Design & Production 2023",
        "desc": "Iris (or star) must navigate dangerous worlds to cure an evil curse",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/DDP2023/index.html"
    }, {
        "id": 12,
        "title": "The Journey of Life",
        "author": "Terriesa",
        "desc": "Impact Academy Fall 2023",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/Terriesa23/index.html"
    }, {
        "id": 13,
        "title": "The Mysterious Fire",
        "author": "Ethan",
        "desc": "Impact Academy Fall 2023",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/Ethan23/index.html"
    }, {
        "id": 14,
        "title": "Turtles",
        "author": "Jena",
        "desc": "Impact Academy Fall 2023",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/Jena23/index.html"
    }, {
        "id": 15,
        "title": "Yankee Fun Run",
        "author": "Deondrey",
        "desc": "Impact Academy Fall 2023",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/Deondrey23/index.html"
    }, {
        "id": 16,
        "title": "Sam's Adventures",
        "author": "Zion",
        "desc": "Impact Academy Fall 2023",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/Zion23/index.html"
    }, {
        "id": 17,
        "title": "The Infected",
        "author": "Alex",
        "desc": "Impact Academy Fall 2023",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/Alex23/index.html"
    }, {
        "id": 18,
        "title": "Spongebob Adventure",
        "author": "Jada",
        "desc": "Impact Academy Fall 2023",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/Jada23/index.html"
    }, {
        "id": 19,
        "title": "Space Conquerers",
        "author": "Jumel",
        "desc": "Impact Academy Fall 2023",
        "resX": "800",
        "resY": "600",
        "link": "https://arcaderepo.netlify.com/games/Jumel23/index.html"
    }
]
